import { render } from "./CmsProductRevisionListItem.vue?vue&type=template&id=909e9f32&scoped=true"
import script from "./CmsProductRevisionListItem.vue?vue&type=script&lang=js"
export * from "./CmsProductRevisionListItem.vue?vue&type=script&lang=js"

import "./CmsProductRevisionListItem.vue?vue&type=style&index=0&id=909e9f32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909e9f32"]])

export default __exports__